import React from 'react';
import './TrendAnalysis.css';

const TrendAnalysis = ({ employees }) => {
  // 获取所有历史记录并按日期排序
  const allHistory = employees
    .flatMap(emp => emp.history || [])
    .sort((a, b) => new Date(b.date) - new Date(a.date));  // 按日期降序排列

  return (
    <div className="trend-analysis">
      <div className="trend-header">
        <h2>发展轨迹记录</h2>
        <div className="summary-stats">
          <div className="stat-item">
            <div className="stat-value">{allHistory.length}</div>
            <div className="stat-label">总变动次数</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">
              {new Set(allHistory.map(h => h.employeeName)).size}
            </div>
            <div className="stat-label">涉及人数</div>
          </div>
        </div>
      </div>

      <div className="trend-details">
        <div className="history-table">
          <table>
            <thead>
              <tr>
                <th>日期</th>
                <th>员工</th>
                <th>原类别</th>
                <th>新类别</th>
                <th>变动原因</th>
              </tr>
            </thead>
            <tbody>
              {employees
                .flatMap(emp => 
                  (emp.history || []).map(record => ({
                    ...record,
                    employeeName: emp.name
                  }))
                )
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((record, index) => (
                  <tr key={index}>
                    <td>{new Date(record.date).toLocaleDateString()}</td>
                    <td>{record.employeeName}</td>
                    <td>{record.fromCategory}</td>
                    <td>{record.toCategory}</td>
                    <td>{record.reason || '-'}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TrendAnalysis; 